import FilterSortOption from '../FilterSortOption';

import type { OnApplyFilter } from '@hotels-hotel-detail/data-access/types/hotel-reviews';
import type { FilterGroup } from '@shared/types/frontend/ubff/hotel-reviews';

import { useHotelReviewsContext } from '@hotels-hotel-detail/data-access/hooks/useHotelReviewsContext';
import DropdownSelector from '@hotels-hotel-detail/ui/DropdownSelector';
import { getSelectedFilterItem } from '@hotels-hotel-detail/utils/review-service';

type Props = {
  groups: FilterGroup[];
  disabled?: boolean;
  applyFilter: OnApplyFilter;
};

const FilterGroups = ({ applyFilter, disabled, groups }: Props) => {
  const { filters: selectedFilters } = useHotelReviewsContext();

  return (
    <>
      {groups.map(({ displayText, filters, type }) => (
        <DropdownSelector
          key={type}
          id={`${type}-dropdown-selector`}
          title={displayText}
          disabled={disabled}
          {...getSelectedFilterItem({
            displayText,
            filterOptions: filters,
            filterType: type,
            selectedFilters,
          })}
        >
          <>
            {filters.map(
              ({ displayText: optionDisplayText, selected, value }) => (
                <FilterSortOption
                  key={value}
                  value={value}
                  filterType={type}
                  displayText={optionDisplayText}
                  checked={selected}
                  onOptionChanged={() => applyFilter({ type, value })}
                />
              ),
            )}
          </>
        </DropdownSelector>
      ))}
    </>
  );
};

export default FilterGroups;
